
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { SALES } from '../../taskboard/taskboard.help';
import { SelectedPartnerService } from '../../services/partner/selectedPartner.service';
import { StorageOptions } from '../../template/shared/proto/storage/StorageOptions';
import { StorageService } from '../../template/shared/proto/storage/storage.service';

const SALES_MENU: any = [
  {
    title: 'PARDAVIMAI',
    icon: 'zmdi zmdi-balance',
    entries: [
      {
        title: 'Pardavimai',
        isActive: false,
        routerLink: SALES,
      },
    ]
  },
];

@Component({
  selector: 'sales-menu',
  templateUrl: './sales-menu.component.html',
  styleUrls: ['./sales-menu.component.scss']
})
export class SalesMenuComponent implements OnInit, OnDestroy {

  showMenu: boolean = false;
  prevMenu: any;
  currentMenu: any;
  private _subscriptions: Array<Subscription> = [];
  private _pageSavingOptions: StorageOptions = {
    popState: true,
    refresh: true
  };

  constructor(
    private selectedPartnerService: SelectedPartnerService,
    private _storageService: StorageService,
  ) {
  }

  ngOnInit() {
    this.selectedPartnerService.resetPartner();
    this.selectedPartnerService.resetUser();
    this.currentMenu = SALES_MENU.map((el) => { return { ...el, isActive: false } });
    this.showMenu = true;
  }

  resetPageSessionStorage() {
    this._storageService.store('currentPage', 0, this._pageSavingOptions);
  }

  ngOnDestroy(): void {
    this._subscriptions.forEach((sp) => sp.unsubscribe());
  }
}
